import { makeStyles, tokens } from '@fluentui/react-components';
import { fontScale } from '@/theme';

export const useEventFilterPanelStyles = makeStyles({
  drawerBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalL,
    paddingTop: tokens.spacingVerticalM,
    paddingBottom: tokens.spacingVerticalM,
    overflowY: 'auto',
    flex: 1,
  },
  fieldGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalS,
  },
  footer: {
    display: 'flex',
    flexDirection: 'row',
    gap: tokens.spacingHorizontalS,
    paddingTop: tokens.spacingVerticalM,
    paddingBottom: tokens.spacingVerticalM,
    borderTopWidth: '0.0625rem',
    borderTopStyle: 'solid',
    borderTopColor: tokens.colorNeutralStroke1,
  },
  clearSelectionButton: {
    cursor: 'pointer',
    fontSize: fontScale.caption,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorBrandForeground1,
    paddingTop: tokens.spacingVerticalXS,
    paddingBottom: tokens.spacingVerticalXS,
    paddingLeft: tokens.spacingHorizontalS,
  },
  inlineClearSelection: {
    cursor: 'pointer',
    fontSize: fontScale.caption,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorBrandForeground1,
    paddingTop: tokens.spacingVerticalSNudge,
    paddingBottom: tokens.spacingVerticalSNudge,
    paddingLeft: tokens.spacingHorizontalS,
    paddingRight: tokens.spacingHorizontalS,
    borderBottom: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`,
    ':hover': {
      backgroundColor: tokens.colorNeutralBackground1Hover,
    },
  },
  ownerListbox: {
    maxHeight: '21.75rem !important' as unknown as string,
  },
});
